import type { VoterDoorVisitsQuery } from '../../graphql/queries/voterDoorVisits.generated';
import { VOTER_VISITS_ERROR_FALLBACK, fetchVoterDoorVisits, type VoterFetchImpl } from './voterApi';
import { useVoterRequest, type VoterRequestState } from './useVoterRequest';

export type VoterDoorVisitRecord = NonNullable<VoterDoorVisitsQuery['voterDoorVisits']>['items'][number];
export type VoterDoorVisitsData = NonNullable<VoterDoorVisitsQuery['voterDoorVisits']>;

export type UseVoterDoorVisitsOptions = {
  id: string;
  page: number;
  rowsPerPage: number;
  fetchImpl?: VoterFetchImpl;
};

export const useVoterDoorVisits = ({
  id,
  page,
  rowsPerPage,
  fetchImpl,
}: UseVoterDoorVisitsOptions): VoterRequestState<VoterDoorVisitsData> =>
  useVoterRequest(
    JSON.stringify([id, page, rowsPerPage]),
    signal => fetchVoterDoorVisits({ id, first: rowsPerPage, offset: page * rowsPerPage, signal, fetchImpl }),
    VOTER_VISITS_ERROR_FALLBACK,
    fetchImpl,
  );
